import type { Qty } from '../../lib/format';

interface Series {
  key: string;
  label: string;
  color: string;
  data: Qty;
}

/**
 * Barres groupées : une colonne par type de caisse (PM, GM, ...), une barre par
 * série (Central / Marjane / Perdu). Étiquettes directes en valeur — le volume
 * de données reste petit (quelques types x 3 séries), donc l'étiquette lit
 * mieux qu'une infobulle seule ; le titre natif reste en renfort au survol.
 */
export function StockByTypeChart({ items, series }: { items: string[]; series: Series[] }) {
  const max = Math.max(1, ...series.flatMap((s) => items.map((it) => s.data[it] || 0)));

  if (items.length === 0) {
    return <p className="muted">Aucun type de caisse configuré.</p>;
  }

  return (
    <>
      <div className="chart-legend">
        {series.map((s) => (
          <span className="litem" key={s.key}>
            <span className="ldot" style={{ background: s.color }} />
            {s.label}
          </span>
        ))}
      </div>
      <div className="stockchart">
        {items.map((item) => (
          <div className="grp" key={item}>
            <div className="bars">
              {series.map((s) => {
                const v = s.data[item] || 0;
                const h = Math.max(2, Math.round((v / max) * 140));
                return (
                  <div
                    key={s.key}
                    className="bar"
                    title={`${s.label} — ${item} : ${v}`}
                    style={{ height: h, background: s.color }}
                  >
                    {v > 0 && <span className="barval">{v}</span>}
                  </div>
                );
              })}
            </div>
            <span className="grplbl">{item}</span>
          </div>
        ))}
      </div>
    </>
  );
}
